import React from 'react';
import { Column, Row } from '../../../../../../shared/components/Grid/Grid';
import number from '../../../../../../shared/util/utilities/number';
import date from '../../../../../../shared/util/utilities/date';
import { Badge } from '@economic/gaudi';
import { t } from '../../../../../../shared/components/l10n/l10n';
import { MoneyflowOfferOverviewResult } from '../../../../../../../types/internal-api';

type Props = {
    offer: MoneyflowOfferOverviewResult;
    customer: any;
};

export default function MoneyflowInvoiceStatusDetails({ offer, customer }: Props) {
    return (
        <div className="leading-8">
            <Row>
                <Column>
                    <h3 className="font-bold text-base">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_HEADER`}</h3>
                </Column>
            </Row>

            <Row>
                <Column>
                    <div className="">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_CUSTOMER`}</div>
                </Column>
                <Column>
                    <div className="text-right">{customer.name}</div>
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_AMOUNT`}</div>
                </Column>
                <Column>
                    <div className="text-right">{number.format(offer.offerAmount)} DKK</div>
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_STATUS`}</div>
                </Column>
                <Column>
                    <div className="text-right">
                        <Badge state="information">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_STATUS_VALUE`}</Badge>
                    </div>
                </Column>
            </Row>
            <Row>
                <Column>
                    <div className="">{t`FORM_BOOKANDSEND_MONEYFLOW_POSTSALE_DETAILS_DATE`}</div>
                </Column>
                <Column>
                    <div className="text-right">{date.format(new Date())}</div>
                </Column>
            </Row>
        </div>
    );
}
